import { render, staticRenderFns } from "./codequality_issue_body.vue?vue&type=template&id=013540b2&"
import script from "./codequality_issue_body.vue?vue&type=script&lang=js&"
export * from "./codequality_issue_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "codequality_issue_body.vue"
export default component.exports